import React, { useState } from 'react';
import { useI18n } from 'react-simple-i18n';
import appstate, { getLocaledString } from '../appstate';
import line1 from '../assets/img/lines/1-svg.svg';
import vjuga1 from '../assets/img/lines/vjuga1.png';
import vjuga2 from '../assets/img/lines/vjuga2.png';
import tw1 from '../assets/img/tw1.jpg';
import PasicaComponent from '../components/pasicaComponent/pasicaComponent';

export function MeasuresQuiz() {
	const { t } = useI18n();

	const initialQuestionsAndAnswers = () => {
		const questions = Object.values(
			appstate.currentLangData()?.quiz?.questions || {},
		);

		return questions.map((q) => {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			const { question, answers } = q;

			return {
				question,
				answers,
				chosenAnswer: undefined,
			};
		});
	};

	const getAnswersArray = (answers: object) => {
		return Object.values(answers).map((a) => {
			return a;
		});
	};

	const getMeasuresForAnswers = () => {
		// Todo...
		return [
			...Object.values(appstate.currentLangData().quiz.measures).map(
				(a) => {
					return a;
				},
			),
		];
	};

	const [isStarted, setIsStarted] = React.useState(false);
	const [isFinished, setIsFinished] = React.useState(false);
	const [currentQuestion, setCurrentQuestion] = React.useState(0);
	const [questionsAndAnswers, setQuestionsAndAnswers] = React.useState(
		initialQuestionsAndAnswers(),
	);
	const [expandedMeasures, setExpandedMeasures] = React.useState<string[]>(
		[],
	);

	const resetAnswersInLocalStorage = () => {
		localStorage.removeItem('quizAnswers');
	};

	const saveAnswersToLocalStorage = () => {
		localStorage.setItem(
			'quizAnswers',
			JSON.stringify(questionsAndAnswers),
		);
	};

	const getAnswersFromLocalStorage = () => {
		if (!localStorage.getItem('quizAnswers')) {
			return undefined;
		}

		const answers = JSON.parse(localStorage.getItem('quizAnswers') || '[]');

		return answers;
	};

	// When the component mounts, we check if there are answers in local storage
	React.useEffect(() => {
		const answers = getAnswersFromLocalStorage();

		try {
			questionsAndAnswers.map((q, i) => {
				return {
					...q,
					chosenAnswer: answers[i].chosenAnswer,
				};
			});
		} catch (e) {
			resetAnswersInLocalStorage();
		}

		if (answers) {
			setQuestionsAndAnswers(
				questionsAndAnswers.map((q, i) => {
					return {
						...q,
						chosenAnswer: answers[i]?.chosenAnswer,
					};
				}),
			);

			setIsStarted(true);
			setIsFinished(true);
		}
	}, []);

	const points = () => {
		const points = questionsAndAnswers.reduce((acc, qa) => {
			if (qa.chosenAnswer === getLocaledString('Da', 'Yes')) {
				return acc + 1;
			} else if (
				qa.chosenAnswer === getLocaledString('Včasih', 'Sometimes')
			) {
				return acc + 0.5;
			}
			return acc;
		}, 0);

		return points;
	};

	if (!isStarted) {
		return (
			<div
				className={
					'w-full cloud-bg text-secondary-800 text-primary-700 h-124 rounded shadow border overflow-hidden p-8 flex flex-col justify-center items-center gap-8 pb-24 relative pt-20 -mb-12'
				}
			>
				<div
					className={
						'absolute w-full h-full top-0 left-0 z-0 opacity-15 blur-sm'
					}
					style={{
						backgroundImage: `url(${tw1})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				/>
				<button
					className={'button-primary mt-3 z-20'}
					onClick={() => {
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
						window['gtag']('event', 'user_engagement', {
							event_category: 'quiz',
							event_label: 'quiz started',
						});
						setIsStarted(true);
					}}
				>
					{appstate.currentLanguage() === 'slSI'
						? 'Prični z reševanjem'
						: 'Take the quiz'}
				</button>
			</div>
		);
	}

	if (isFinished) {
		return (
			<div
				className={
					'w-full cloud-bg text-black h-124 mt-4 rounded shadow overflow-y-scroll p-8 relative -mb-12'
				}
			>
				<h1
					className={
						'text-center lg:px-20 my-4 lg:my-8 lg:mb-12 text-sm lg:text-2xl font-bold z-20'
					}
				>
					{appstate.currentLanguage() === 'slSI'
						? 'Obstoječe stanje v vašem podjetju:'
						: 'The state of your company:'}
				</h1>
				<div className={'text-xs lg:text-lg px-4'}>
					{points() <= 3 &&
						(appstate.currentLanguage() === 'slSI' ? (
							<div>
								Do zdaj podjetje na žalost še ni resno naslovilo
								usklajevanja poklicnega in zasebnega življenja
								ter vključevanja vidika enakosti spolov v vse
								operacije podjetja. Zaradi manka interesa v
								podjetju se še niso oblikovale in izvedle
								konkretne politike in ukrepi, ki bi spodbujali
								in zagotavljali usklajevanje poklicnega in
								zasebnega življenja zaposlenim ter nudili enake
								priložnosti vsem ženskam in moškim. Za zaposlene
								v vsakem podjetju je izrednega pomena, da se s
								strani podjetja čutijo slišane, spoštovane in
								vključene. Že z najmanjšimi premiki lahko
								podjetja prispevajo k večjemu zadovoljstvu
								zaposlenih na delovnem mestu in s tem spodbudijo
								občutke motiviranosti, kreativnosti in
								produktivnosti tako na ravni posameznika kot
								celotnega podjetja. <br />
								<br />
								Podjetje mora v prihodnjem delovanju oblikovati
								in implementirati politike in ukrepe, ki bodo
								zagotavljali enake priložnosti vsem zaposlenim
								ter jim pomagali pri usklajevanju poklicnega in
								zasebnega življenja. Vsaka oseba, zaposlena v
								podjetju, si zaluži enake priložnosti tekom
								zaposlovanja, dela in napredovanja. Nižje na
								strani so na voljo ukrepi tako za vodstveni
								kader kot za vse zaposlene, ki se jih lahko
								vsaka skupina posluži z namenom ozaveščanja o
								možnih spremembah, ki jih podjetje lahko (v
								prilagojeni obliki) realizira z namenom boljšega
								naslavljanja usklajevanja poklicnega in
								zasebnega življenja in enakosti spolov na
								delovnem mestu.
							</div>
						) : (
							<>
								<p className="p1 mb-2">
									Until now, unfortunately, the company has
									not seriously addressed work-life balance
									and gender mainstreaming in all company
									operations. Due to the lack of interest in
									the company, concrete policies and measures
									have not yet been formulated and
									implemented, which would encourage and
									ensure the coordination of professional and
									private life for employees and offer equal
									opportunities to all women and men.
								</p>
								<p className="p1 mb-2">
									It is extremely important for employees in
									every company to feel heard, respected and
									included by the company. Even with the
									smallest changes, companies can contribute
									to greater employee satisfaction in the
									workplace and thus stimulate feelings of
									motivation, creativity and productivity both
									at the level of the individual and the
									entire company.
								</p>
								<p className="p1 mb-2">
									In future operations, the company must
									design and implement policies and measures
									that will provide equal opportunities to all
									employees and help them balance their
									professional and private lives. Every person
									employed by the company deserves equal
									opportunities during recruitment, work and
									promotion.
								</p>
							</>
						))}
					{points() > 3 &&
						points() <= 7 &&
						(appstate.currentLanguage() === 'slSI' ? (
							<div>
								Do zdaj je podjetje že izkazalo interes, da se
								prilagodi spreminjajočim se potrebam in
								pričakovanjem zaposlenih, z oblikovanjem in
								izvajanjem določenih politik in ukrepov, ki
								omogočajo lažje usklajevanje poklicnega in
								zasebnega življenja ter nudijo enake priložnosti
								vsem ženskam in moškim, ki delajo v podjetju.
								Oblikovanje in implementacija takih pobud kaže
								tudi na sposobnost podjetja, da prepozna njihov
								potencial, v smislu njihovega vpliva na
								zadovoljstvo, motiviranost in produktivnost
								zaposlenih. <br />
								<br />
								Kljub določenim pozitivnim trudom podjetja, da
								prispeva k lajšanju poklicnega in zasebnega
								življenja zaposlenih ter slednjim nudi enake
								priložnosti, mora podjetje nasloviti še nekaj
								manjkajočih segmentov, z namenom nudenja
								resnično učinkovitih, nediskriminatornih in
								prilagojenih ukrepov za boljše usklajevanje
								poklicnih in zasebnih obveznosti. To lahko stori
								s sprejemanjem novih internih aktov,
								modifikacijo obstoječih politik podjetja,
								izvajanjem inovativnih pobud in oblikovanjem
								celostnih izobraževalnih programov za vodstven
								kader kot ostale zaposlene na temo usklajevanja
								poklicnega in zasebnega življenja.
							</div>
						) : (
							<>
								<p className="p1 mb-2">
									Until now, the company has already shown an
									interest in adapting to the changing needs
									and expectations of employees, by creating
									and implementing certain policies and
									measures that facilitate the reconciliation
									of professional and private life and offer
									equal opportunities to all women and men
									working in the company. Designing and
									implementing such initiatives also shows the
									{/* eslint-disable-next-line react/no-unescaped-entities */}
									company's ability to recognize their
									potential, in terms of their impact on
									employee satisfaction, motivation and
									productivity.
								</p>
								<p className="p1 mb-2">
									Despite certain positive efforts of the
									company to contribute to the facilitation of
									the professional and private life of
									employees and to provide the latter with
									equal opportunities, the company still needs
									to address some missing segments, with the
									aim of offering truly effective,
									non-discriminatory and customized measures
									to better balance professional and private
									obligations. It can do this by adopting new
									internal acts, modifying existing company
									policies, implementing innovative
									initiatives and creating integrated training
									programs for management staff and other
									employees on the topic of balancing
									professional and private life.
								</p>
							</>
						))}
					{points() > 7 &&
						(appstate.currentLanguage() === 'slSI' ? (
							<div>
								Podjetje aktivno in uspešno oblikuje, promovira
								in izvaja politike ter ukrepe za usklajevanje
								poklicnega in zasebnega življenja ter nudenje
								enakih priložnosti vsem ženskam in moškim.
								Podjetje je odgovorno in zanesljivo ter spodbuja
								zaposlene, da komunicirajo svoje potrebe in
								pričakovanja, z namenom doslednega prilagajanja
								politik in ukrepov. S tem podjetje prispeva k
								izkoristku potenciala vseh svojih zaposlenih in
								prispeva k boljšemu počutju na delovnem mestu,
								posledično pa tudi k višji motiviranosti,
								kreativnosti in produktivnosti na ravni vsake_ga
								zaposlene_ga in na ravni celotnega podjetja.
								<br />
								<br />Z namenom ohranjanja uspešnosti na obeh
								področjih, so za podjetje priporočljive
								naslednje nadgradnje obstoječih praks: vpeljava
								sistema za merjenje zadovoljstva zaposlenih na
								delovnem mestu, oblikovanje in implementacija
								načrta za enakost spolov in oblikovanje
								celostnega programa za vzdrževanje dobre
								organizacijske kulture.
							</div>
						) : (
							<>
								<p className="p1 mb-2">
									The company actively and successfully
									formulates, promotes and implements policies
									and measures for harmonizing professional
									and private life and offering equal
									opportunities to all women and men. The
									company is responsible and reliable and
									encourages employees to communicate their
									needs and expectations, with the aim of
									consistently adapting policies and measures.
									In this way, the company contributes to the
									utilization of the potential of all its
									employees and contributes to better
									well-being at the workplace, as well as to
									higher motivation, creativity and
									productivity at the level of each employee
									and at the level of the entire company.
								</p>
								<p className="p1 mb-2">
									In order to maintain success in both areas,
									the following upgrades to existing practices
									are recommended for the company:
									introduction of a system for measuring
									employee satisfaction at the workplace,
									design and implementation of a plan for
									gender equality, and design of a
									comprehensive program for maintaining a good
									organizational culture.
								</p>
							</>
						))}
				</div>
				<div className={'mt-5'}>
					<div
						className={
							'flex justify-center items-center border-t pt-8'
						}
					>
						<button
							className={'button-primary reversed'}
							onClick={() => {
								setQuestionsAndAnswers(
									initialQuestionsAndAnswers(),
								);

								resetAnswersInLocalStorage();
								setQuestionsAndAnswers(
									initialQuestionsAndAnswers(),
								);
								setIsStarted(false);
								setIsFinished(false);
								setCurrentQuestion(0);
							}}
						>
							{appstate.currentLanguage() === 'slSI'
								? 'Ponovno reši kviz'
								: 'Take the quiz again'}
						</button>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div
			className={
				'w-full cloud-bg-light text-black h-124 mt-4 rounded shadow border overflow-hidden p-8 flex flex-col justify-center items-center gap-8 pb-24 relative'
			}
		>
			<div
				className={
					'absolute w-full h-full top-0 left-0 z-0 opacity-15 blur-sm text-center'
				}
				style={{
					backgroundImage: `url(${tw1})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
			/>
			<div>
				<h1
					className={
						'text-primary-500 text-xs lg:text-2xl font-bold z-20 text-center'
					}
				>
					{questionsAndAnswers[currentQuestion].question}
				</h1>
			</div>
			<div
				className={`flex ${
					currentQuestion === -1
						? 'flex-row justify-center'
						: 'flex-col'
				} gap-4 z-20`}
			>
				{getAnswersArray(
					questionsAndAnswers[currentQuestion].answers,
				).map((a, i) => {
					return (
						<button
							key={a}
							className={`button-primary !px-14 z-20 shadow ${
								currentQuestion === -1 && 'w-1/3 h-32 !text-2xl'
							}`}
							onClick={() => {
								const updatedQuestionsAndAnswers =
									questionsAndAnswers.map((q, i) => {
										if (i === currentQuestion) {
											return {
												...q,
												chosenAnswer: a,
											};
										}

										return q;
									});

								setQuestionsAndAnswers(
									updatedQuestionsAndAnswers,
								);

								if (
									currentQuestion + 1 >
									questionsAndAnswers.length - 1
								) {
									setIsFinished(true);
									saveAnswersToLocalStorage();
								} else {
									setCurrentQuestion(currentQuestion + 1);
								}
							}}
						>
							{a}
						</button>
					);
				})}
			</div>
			<div className={'absolute bottom-0 left-0 mb-5 ml-5 z-20'}>
				{currentQuestion !== 0 && (
					<button
						className={'button-primary reversed'}
						onClick={() => {
							setCurrentQuestion(currentQuestion - 1);
							setIsFinished(false);
						}}
					>
						Nazaj
					</button>
				)}
			</div>
		</div>
	);
}

function MeasureSections(props: { type: number }) {
	const getEmployeeMeasuresSlice = (start: number, end: number) => {
		return Object.entries(appstate.currentLangData()?.quiz.employeeMeasures)
			.slice(start, end)
			.map((m) => {
				return m;
			});
	};

	const getMeasuresSlice = (start: number, end: number) => {
		return Object.entries(appstate.currentLangData()?.quiz.measures)
			.slice(start, end)
			.map((m) => {
				return m;
			});
	};

	const getMeasuresForSelectedSection = () => {
		if (appstate.currentLanguage() === 'slSI') {
			if (props.type === 2) {
				if (activeSection === 'Informiranje in komuniciranje') {
					return [...getEmployeeMeasuresSlice(0, 7)];
				}

				if (activeSection === 'Zadovoljstvo na delovnem mestu') {
					return [...getEmployeeMeasuresSlice(7, 14)];
				}

				if (activeSection === 'Delovni čas in organizacija dela') {
					return [...getEmployeeMeasuresSlice(14, 30)];
				}

				return [...getEmployeeMeasuresSlice(0, 1)];
			}

			if (activeSection === 'Delovni čas in organizacija dela') {
				return [...getMeasuresSlice(0, 10)];
			}

			if (activeSection === 'Informiranje in komuniciranje') {
				return [...getMeasuresSlice(10, 15)];
			}

			if (activeSection === 'Veščine vodstva') {
				return [...getMeasuresSlice(15, 20)];
			}

			if (activeSection === 'Zaposlovanje in razvoj kadrov') {
				return [...getMeasuresSlice(20, 32)];
			}

			if (activeSection === 'Nagrajevanje in napredovanje') {
				return [...getMeasuresSlice(32, 38)];
			}

			if (activeSection === 'Zadovoljstvo na delovnem mestu') {
				return [...getMeasuresSlice(38, 43)];
			}

			if (activeSection === 'Skrbstveno delo') {
				return [...getMeasuresSlice(43, 50)];
			}
		} else if (appstate.currentLanguage() === 'enUK') {
			if (props.type === 2) {
				if (activeSection === 'Communication') {
					return [...getEmployeeMeasuresSlice(0, 4)];
				}

				if (activeSection === 'Job satisfaction') {
					return [...getEmployeeMeasuresSlice(4, 12)];
				}

				if (activeSection === 'Work hours organization') {
					return [...getEmployeeMeasuresSlice(12, 99)];
				}

				return [...getEmployeeMeasuresSlice(0, 1)];
			}

			if (activeSection === 'Leadership skills') {
				return [...getEmployeeMeasuresSlice(0, 5)];
			}

			if (
				activeSection === 'Recruitment and development of new personnel'
			) {
				return [...getEmployeeMeasuresSlice(5, 16)];
			}

			if (activeSection === 'Care work') {
				return [...getEmployeeMeasuresSlice(16, 22)];
			}

			if (activeSection === 'Rewarding and promotion') {
				return [...getMeasuresSlice(22, 28)];
			}

			if (activeSection === 'Communication') {
				return [...getMeasuresSlice(28, 33)];
			}

			if (activeSection === 'Job satisfaction') {
				return [...getMeasuresSlice(33, 38)];
			}

			if (activeSection === 'Work hours organization') {
				return [...getMeasuresSlice(43, 99)];
			}
		}

		return [...getMeasuresSlice(0, 4)];
	};

	const sections = () => {
		if (appstate.currentLanguage() === 'slSI') {
			if (props.type === 1) {
				return [
					'Veščine vodstva',
					'Zaposlovanje in razvoj kadrov',
					'Nagrajevanje in napredovanje',
					'Skrbstveno delo',
					'Informiranje in komuniciranje',
					'Zadovoljstvo na delovnem mestu',
					'Delovni čas in organizacija dela',
				];
			} else {
				return [
					'Informiranje in komuniciranje',
					'Zadovoljstvo na delovnem mestu',
					'Delovni čas in organizacija dela',
				];
			}
		} else {
			if (props.type === 1) {
				return [
					'Leadership skills',
					'Recruitment and development of new personnel',
					'Care work',
					'Rewarding and promotion',
					'Communication',
					'Job satisfaction',
					'Work hours organization',
				];
			} else {
				return [
					'Communication',
					'Job satisfaction',
					'Work hours organization',
				];
			}
		}
	};

	const [activeSection, setActiveSection] = useState<string | undefined>(
		undefined,
	);
	const [slideOut, setSlideOut] = useState(false);
	const [expandedMeasures, setExpandedMeasures] = React.useState<string[]>(
		[],
	);

	// console.log(getMeasuresForSelectedSection());

	const colSpanFor = (index: number) => {
		const rr = index % 7;

		if (props.type === 2) {
			if (rr === 0) {
				return 6;
			}
			if (rr === 1) {
				return 6;
			}
			if (rr === 2) {
				return 12;
			}
		}

		if (rr === 0) {
			return 6;
		}
		if (rr === 1) {
			return 6;
		}
		if (rr === 2) {
			return 7;
		}
		if (rr === 3) {
			return 5;
		}
		if (rr === 4) {
			return 6;
		}
		if (rr === 5) {
			return 6;
		}
		if (rr === 6) {
			return 12;
		}
		if (rr === 7) {
			return 12;
		}
		return 12;
	};

	const colSpanForOther = (index: number) => {
		const rr = index % 8;

		return 12;
	};

	return (
		<>
			<div className={'grid grid-cols-12 gap-12 relative mb-16 h-fit'}>
				<div
					className={`absolute top-0 w-full left-0 flex flex-col flex-wrap gap-4 col-span-12 flex flex-row grid grid-cols-12 transform transition duration-300 ${
						activeSection !== undefined
							? '-translate-x-full opacity-0'
							: 'translate-x-0 opacity-100'
					}`}
				>
					{sections().map((s, index) => {
						return (
							<button
								key={s}
								className={`shadow button-primary !h-24 no-arrow col-span-${colSpanFor(
									index,
								)} ${activeSection === s && 'active'}`}
								onClick={() => {
									if (activeSection !== s) {
										setSlideOut(true);
										setTimeout(() => {
											setActiveSection(s);
											requestAnimationFrame(() => {
												setSlideOut(false);
											});
										}, 150);
									}
								}}
							>
								{s}
							</button>
						);
					})}
				</div>
				<div
					className={`col-span-12 duration-300 ${
						activeSection === undefined
							? '-translate-x-full opacity-0'
							: 'translate-x-0 opacity-100'
					}`}
					style={{ maxWidth: '99vw' }}
				>
					<div
						className={`transform transition ${
							slideOut
								? '-translate-x-24 opacity-0'
								: 'translate-x-0 opacity-100'
						}`}
					>
						<h1
							className={
								'text-2xl font-bold mb-6 lg:text-center text-primary-500 max-w-full'
							}
						>
							{activeSection}
						</h1>
						<div className={'grid grid-cols-12 gap-x-4 mb-4'}>
							{getMeasuresForSelectedSection().map(
								(m: any, i: number) => {
									return (
										<div
											key={i}
											className={`shadow mb-4 bg-white flex justify-center items-center col-span-${colSpanForOther(
												i,
											)}`}
											style={{
												maxWidth:
													window.innerWidth < 1024
														? '90vw'
														: 'unset',
											}}
										>
											<div
												className={
													'cursor-pointer font-bold group flex flex-row items-center'
												}
												onClick={() => {
													if (
														expandedMeasures.includes(
															m[1].title,
														)
													) {
														setExpandedMeasures(
															expandedMeasures.filter(
																(mm) => {
																	return (
																		mm !==
																		m[1]
																			.title
																	);
																},
															),
														);
													} else {
														setExpandedMeasures([
															...expandedMeasures,
															m[1].title,
														]);
													}
												}}
											>
												<div
													className={`Oswald inline-flex transform transition -ml-0.5 ${
														expandedMeasures.includes(
															m[1].title,
														)
															? 'rotate-90 opacity-100 translate-x-5 translate-y-0.5'
															: 'opacity-0 group-hover:translate-x-5 group-hover:opacity-100'
													}`}
												>
													{'>'}
												</div>
												<div
													className={`p-4 font-bold transform transition group-hover:translate-x-4 pr-12 text-center max-w-full ${
														expandedMeasures.includes(
															m[1].title,
														)
															? 'translate-x-4'
															: 'translate-x-0 '
													}`}
												>
													{m[1].title}
												</div>
											</div>
										</div>
									);
								},
							)}
						</div>
						<div className={'pt-8 border-t mt-4 text-center'}>
							<button
								onClick={() => {
									setActiveSection(undefined);
									const lchash =
										props.type === 1
											? 'employers'
											: 'employees';

									if (location.hash) {
										requestAnimationFrame(() => {
											const element =
												document.getElementById(lchash);
											if (element) {
												element!.scrollIntoView({
													behavior: 'smooth',
												});
											}
										});
									}
								}}
								className={'button-primary reversed'}
							>
								{getLocaledString(
									'Nazaj na vse sklope',
									'Back to all categories',
								)}
							</button>
						</div>
					</div>
				</div>
			</div>
			{expandedMeasures.length > 0 && (
				<div
					className={
						'fixed top-0 left-0 w-full h-full bg-black/30 z-1000 flex justify-center items-center'
					}
					style={{ transform: 'unset' }}
					onClick={(e) => {
						setExpandedMeasures([]);
					}}
				>
					<div
						className={
							'xl:w-3/5 lg:w-2/3 w-3/4 overflow-auto bg-white rounded shadow'
						}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}
					>
						<div
							className={
								'p-10 py-8 mb-12 flex flex-col h-full relative'
							}
						>
							<button
								onClick={() => {
									setExpandedMeasures([]);
								}}
								className={
									'text-xl font-bold absolute top-0 left-0 m-4 ml-5'
								}
							>
								✕
							</button>
							<div className={'text-xl font-bold mt-8'}>
								{expandedMeasures[0].trim()}
							</div>
							<div className={'mt-3 text-base'}>
								{
									// eslint-disable-next-line @typescript-eslint/ban-ts-comment
									// @ts-ignore
									getMeasuresForSelectedSection().find(
										(m: any) => {
											return (
												m[1].title ===
												expandedMeasures[0]
											);
										},
										// eslint-disable-next-line @typescript-eslint/ban-ts-comment
										// @ts-ignore
									)?.[1]?.description
								}
							</div>
							<div className={'flex-1'}>&nbsp;</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default function MeasuresView() {
	const { t } = useI18n();

	return (
		<div>
			<div
				className={'text-lg leading-8 leading-8 mb-12 text-center'}
				dangerouslySetInnerHTML={{
					__html: t('measures.mainCaption'),
				}}
			/>

			<div className={'mt-8'} />

			<PasicaComponent
				title={getLocaledString(
					'Kaj lahko naredim kot vodja za lajšanje usklajevanja poklicnega in zasebnega življenja zaposlenih?',
					'What can I do as a manager and/or employer to facilitate work-life balance for employees?',
				)}
				h1={'employers'}
			/>

			<div className={'mb-4'}> &nbsp; </div>

			<MeasureSections type={1} />

			<div className={'mt-24'} />

			<PasicaComponent
				title={getLocaledString(
					'Kaj lahko naredim kot zaposlen_a za lajšanje lastnega usklajevanja poklicnega in zasebnega življenja?',
					'What can I do as an employee to facilitate my own work-life balance?',
				)}
				h1={'employees'}
			/>

			<div className={'mb-4'}> &nbsp; </div>

			<MeasureSections type={2} />
		</div>
	);
}
